import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import { BiStore, BiCalendarEvent, BiBuildings } from 'react-icons/bi';

const QrFlowUseCases = () => {
    const { t } = useTranslations();

    const cases = [
        { icon: <BiStore />, key: '1' },
        { icon: <BiCalendarEvent />, key: '2' },
        { icon: <BiBuildings />, key: '3' },
    ];

    return (
        <section className="qr-flow-use-cases">
            <div className="container">
                <FadeInAnimation direction="up" delay={50}>
                    <div className="qr-flow-use-cases__intro">
                        <span className="qr-flow-use-cases__badge">{t('qrFlow_useCases_badge')}</span>
                        <h2>{t('qrFlow_useCases_title')}</h2>
                        <p>{t('qrFlow_useCases_description')}</p>
                    </div>
                </FadeInAnimation>

                <div className="row g-4">
                    {cases.map((item, index) => (
                        <div key={item.key} className="col-lg-4 col-md-6">
                            <FadeInAnimation direction="up" delay={80 + index * 50}>
                                <article className="qr-flow-use-cases__card">
                                    <div className="qr-flow-use-cases__icon">{item.icon}</div>
                                    <h3>{t(`qrFlow_useCases_item${item.key}_title`)}</h3>
                                    <p>{t(`qrFlow_useCases_item${item.key}_desc`)}</p>
                                </article>
                            </FadeInAnimation>
                        </div>
                    ))}
                </div>

                <FadeInAnimation direction="up" delay={200}>
                    <div className="qr-flow-use-cases__workflow">
                        <h3>{t('qrFlow_workflow_title')}</h3>
                        <ol className="qr-flow-use-cases__steps">
                            <li>
                                <strong>{t('qrFlow_workflow_step1_title')}</strong>
                                <span>{t('qrFlow_workflow_step1_desc')}</span>
                            </li>
                            <li>
                                <strong>{t('qrFlow_workflow_step2_title')}</strong>
                                <span>{t('qrFlow_workflow_step2_desc')}</span>
                            </li>
                            <li>
                                <strong>{t('qrFlow_workflow_step3_title')}</strong>
                                <span>{t('qrFlow_workflow_step3_desc')}</span>
                            </li>
                        </ol>
                    </div>
                </FadeInAnimation>
            </div>
        </section>
    );
};

export default QrFlowUseCases;
